import Loading from '../../../shared/Loading/Loading';
import ButtonSort from '../../../shared/ButtonSort';

const ActivitiesTable = ({
  loading,
  filteredActivities,
  query,
  sortConfig,
  handleSort,
  stickyOffset,
}) => {
  return (
    <div className="w-full" style={{ overflow: 'clip' }}>
      {loading ? (
        <div className="flex justify-center py-10">
          <Loading
            size="28"
            colorBase="white"
            colorAccent="personalized"
            double={true}
            bold="8"
          />
        </div>
      ) : filteredActivities.length === 0 ? (
        <div className="px-6 py-8 text-center text-sm text-gray-500">
          {query ? `No hay coincidencias para “${query}”` : 'No hay actividades disponibles'}
        </div>
      ) : (
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50 md:sticky md:z-10" style={{ top: stickyOffset + 12 }}>
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider flex items-center gap-2">
                Nombre
                <ButtonSort
                  handleSort={handleSort}
                  field="Name"
                  direction={sortConfig.direction}
                />
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {filteredActivities.map((activity) => (
              <tr key={activity.Id} className="hover:bg-gray-50">
                <td className="px-6 py-4 whitespace-nowrap text-lg font-medium text-gray-900">
                  {activity.Name}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default ActivitiesTable;
